const IMAGE_BASE_URL =
  'https://fuel-economy-pdf-images.s3.eu-west-2.amazonaws.com/'
const PERCAYSO_IMAGE = 'percayso-vehicle-intelligence.svg'
const CAZOO_IMAGE = 'cazoo-percayso.svg'
const CAZANA_IMAGE = 'cazana-logotype-dark.svg'
const CAZANA_PLACEHOLDER_IMAGE = 'cazana-logotype-white.svg'
const DEFAULT_RESELLER_NAME = 'cazana'

export function formatNumberWithCommas(value) {
  if (value === null || value === undefined || isNaN(value)) return 'N/A'
  return value.toLocaleString('en-GB')
}

export function capitalizeFirstLetterOfString(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : 'N/A'
}

export function calculateMonthsAgoFromDate(dateString) {
  const currentDate = new Date()
  const inputDate = new Date(dateString)

  const monthsAgo =
    (currentDate.getFullYear() - inputDate.getFullYear()) * 12 +
    currentDate.getMonth() -
    inputDate.getMonth()

  return monthsAgo
}

export const getFormattedCondition = condition => {
  if (!condition) return 'N/A'
  return condition === 4 ? 'Poor' : 'Good'
}

export function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : 'N/A'
}

export const getBrandedLogoUrl = organisation => {
  const { logoUrl, useCobrandedReports } = organisation
  if (logoUrl && useCobrandedReports) {
    return logoUrl
  }
  return null
}

export const getReseller = () => {
  const reseller = process.env.VUE_APP_TYPE

  if (reseller === 'motors') {
    return {
      reseller,
      title: 'Cazoo',
      logo: `${IMAGE_BASE_URL}${CAZOO_IMAGE}`,
      logoClass: 'w-auto h-12',
      placeholderLogo: `${IMAGE_BASE_URL}${CAZOO_IMAGE}`,
      placeholderBgClass: 'bg-slate-100',
      primaryColor: '#FFFFFF',
      secondaryColor: '#01190E',
      priceColor: '#01190E'
    }
  }

  if (reseller === 'percayso') {
    return {
      reseller,
      title: 'Percayso',
      logo: `${IMAGE_BASE_URL}${PERCAYSO_IMAGE}`,
      logoClass: 'w-auto h-24',
      placeholderLogo: `${IMAGE_BASE_URL}${PERCAYSO_IMAGE}`,
      placeholderBgClass: 'bg-slate-100',
      primaryColor: '#19A5CC',
      secondaryColor: '#013366',
      priceColor: '#013366'
    }
  }

  return {
    reseller: DEFAULT_RESELLER_NAME,
    title: 'Cazana',
    logo: `${IMAGE_BASE_URL}${CAZANA_IMAGE}`,
    logoClass: 'w-auto h-10',
    placeholderLogo: `${IMAGE_BASE_URL}${CAZANA_PLACEHOLDER_IMAGE}`,
    placeholderBgClass: 'bg-tertiary',
    primaryColor: '#2cdcdb',
    secondaryColor: '#211527',
    priceColor: '#581c87'
  }
}
